<template>
  <div class="banner">
    <div class="banner-add">
      <el-button round type="primary" @click="bannerAdd()">新建banner</el-button>
    </div>
    <div class="banner-title">
      首页banner
      <span class>（建议展示3-5个）</span>
    </div>

    <div class="banner-main">
      <ul v-if="bannerList.length>0">
        <draggable
          :list="bannerList"
          class="list-group"
          ghost-class="ghost"
          @start="dragging = true"
          @end="draggableEnd()"
        >
          <li v-for="(item,index) in bannerList" :key="index">
            <div class="ban-image">
              <img :src="item.banner_cover" alt />
            </div>
            <div class="ban-desc">
              <div class="title">
                <span class="name">{{item.banner_title}}</span>
                <span class="date r">上传时间：{{item.created_at}}</span>
              </div>
              <div class="operation">
                <p>
                  <span class="blue cp" @click="edit(item)">编辑</span>
                  <span class="blue ml20 cp" @click="remove(item)">撤下</span>
                </p>
              </div>
            </div>
          </li>
        </draggable>
      </ul>
    </div>

    <BannerForm
      :bannerVisible.sync="bannerVisible"
      :banner_info="banner_info"
      :banner_type="banner_type"
      :isEdit="isEdit"
      @updateList="updateList"
    ></BannerForm>
  </div>
</template>


<script>
import BannerForm from "./components/banner-form";

import { _bannerList, _bannerSort, _bannerDel } from "@/api/interface.js";

import qs from "qs";

import draggable from "vuedraggable";

export default {
  components: {
    BannerForm,
    draggable
  },
  created() {
    this.initBannerList();
  },
  data() {
    return {
      //拖拽数据操作
      dragging: false,
      //控制子组件的弹窗按钮
      bannerVisible: false,
      banner_info: {},
      banner_type: "1",
      isEdit: false,
      //banner数据
      bannerList: []
    };
  },
  methods: {
    //拖动实时位置和数据
    draggableEnd() {
      this.dragging = false;
      this.bannerSort(this.bannerList);
    },
    //发送排序数据
    bannerSort(data) {
      var data = this.bannerList.map(item => {
        return item.banner_id;
      });
      // console.log(res);
      _bannerSort({
        params: { ids: data }
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    bannerAdd() {
      this.banner_type = "1";
      this.banner_info = {};
      this.isEdit = false;
      this.bannerVisible = true;
    },
    // 请求列表
    initBannerList() {
      _bannerList({
        params: {}
      }).then(res => {
        if (res.resultCode == 1) {
          // console.log(res);
          this.bannerList = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    edit(item) {
      // console.log(item);
      this.banner_type = "2";
      this.banner_info = { ...item };
      this.isEdit = true;
      this.bannerVisible = true;
    },
    remove(item) {
      this.$confirm("您确定要撤下这条banner吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          _bannerDel({
            params: {
              banner_id: item.banner_id
            }
          }).then(res => {
            if (res.resultCode == 1) {
              this.$message.success(res.errorMsg);
              this.initBannerList();
            } else {
              this.$message.error(res.errorMsg);
            }
          });
        })
        .catch(() => {});
    },
    //更新列表数据
    updateList(state) {
      if (state) {
        this.initBannerList();
      }
    }
  }
};
</script>


<style lang="less" scoped>
.banner {
  .banner-add {
    margin-bottom: 20px;
  }
  .banner-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 40px;
    span {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .banner-main {
    ul li {
      overflow: hidden;
      border-bottom: 2px dotted #e7e7e7;
      padding: 20px;
      display: flex;
      .ban-image {
        margin-right: 20px;
        height: 100px;
        width: 100px;
        img {
         width:100px;
        }
      }
      .ban-desc {
        flex: 1;
        .title {
          font-size: 16px;
          margin-bottom: 20px;
          .name {
            font-weight: 600;
          }
          .date {
            color: #a0a0a0;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>